import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-vat-return-data',
  templateUrl: './vat-return-data.component.html',
  styleUrls: ['./vat-return-data.component.scss']
})
export class VatReturnDataComponent implements OnInit {
  
  @Input() public vatReturnData: any;
  vatReturnDataSource = new MatTableDataSource();
  noDataFound = false;
  vatReturnDisplayedColumns: string[] = ['boxNo', 'vatDesc', 'vatAmount'];
  constructor() { }

  ngOnInit(): void {
    this.vatReturnDataSource=this.vatReturnData;
  }

}
